var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.phoneHref}},[_vm._v(" "+_vm._s(_vm.formatPhoneNumber(_vm.phone))+" "),(_vm.extension)?[_vm._v(" "+_vm._s(_vm.$t('phone-number.extension', [_vm.extension]))+" ")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }